export const AppPaths = {
  register: 'registrieren',
  certificate: 'zertifikat',
  unlockUser: 'accountEntsperren',
  deRegister: 'deregistrieren',
}
